import React from 'react';

// One entry of the repayment-schedule timeline.
const PaymentScheduleItem = ({ item }) => {

  return (
    <div>
      <small> {item.period ? "Payment number " + item.period : "Start"}  </small><br />
      <small> Due on Date: </small><h3><strong>{item?.dueDate[2] + "-" + item?.dueDate[1] + "-" + item?.dueDate[0]}</strong></h3>
      <ul>
        <li className='row '>
          <div className='col-md-12 text-left'>
            <p><strong>Amount due : {item.totalInstallmentAmountForPeriod ? "$" + item.totalInstallmentAmountForPeriod : "$0"}</strong></p>
          </div>
        </li>

      </ul>
    </div>
  );
};

// Timeline `content` renderer (defined at module level so it is not re-created on every render).
export const renderPaymentScheduleItem = (item) => <PaymentScheduleItem item={item} />;

export default PaymentScheduleItem;
